/**
 * Lookbook
 */

class LookBookSlider extends HTMLElement {
	constructor() {
		super();

		const productSlider = this.querySelector('tpt-slider-product .swiper');
		const optionString = this.querySelector('tpt-slider-options').innerHTML;
		const optionsJson = JSON.parse(optionString);
		const dotsLookBook = this.querySelectorAll('tpt-lookbook-button');

		this.swiper = new Swiper(productSlider, {
			...optionsJson,
			navigation: {
				nextEl: this.querySelector('.swiper-button-next'),
				prevEl: this.querySelector('.swiper-button-prev'),
			},
			pagination: {
				el: this.querySelector('.swiper-paginations'),
				clickable: true,
			},
		});

		this.swiper.on('slideChange', function () {
			const indexSlide = this.activeIndex;
			const dots = productSlider.closest('tpt-lookbook-slider').querySelectorAll('tpt-lookbook-button');

			dots.forEach((dot) => {
				dot.classList.remove('active');
			});

			dots[indexSlide].classList.add('active');
		});

		dotsLookBook.forEach((dotLookBook) => {
			dotLookBook.addEventListener('click', this.activeItemSlider.bind(this));
			dotLookBook.addEventListener('keypress', this.keyPress.bind(this));
		});
	}

	keyPress(event) {
		if (event.key === 'Enter') {
			this.activeItemSlider(event);
		}
	}

	activeItemSlider(event) {
		const docWidth = document.body.offsetWidth;
		const dotButton = event.target;

		if (docWidth < 768) {
			if (!dotButton.closest('tpt-lookbook-item').querySelector('.lookbook-item-dropdown')) {
				const lookbookUrl = dotButton.getAttribute('data-lookbook-url');
				const lookbookItem = dotButton.closest('tpt-lookbook-item');

				dotButton.closest('tpt-lookbook-item').classList.add('loading');

				fetch(lookbookUrl)
					.then((response) => response.text())
					.then((responseText) => {
						const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
						const productElement = responseHTML.querySelector('[id="shopify-section-tpt-lookbook-item"]');
						lookbookItem.insertAdjacentHTML('beforeend', productElement.innerHTML);
					})
					.finally(() => {
						document.querySelectorAll('tpt-lookbook-item').forEach((lookbookItem) => {
							lookbookItem.classList.remove('active');
						});

						lookbookItem.classList.remove('loading');
						lookbookItem.classList.add('active');
					});
			} else {
				if (dotButton.closest('tpt-lookbook-item').classList.contains('active')) {
					dotButton.closest('tpt-lookbook-item').classList.remove('active');
				} else {
					document.querySelectorAll('tpt-lookbook-item').forEach((lookbookItem) => {
						lookbookItem.classList.remove('active');
					});
					dotButton.closest('tpt-lookbook-item').classList.add('active');
				}
			}
		} else {
			const index = event.target.getAttribute('data-slide-index');
			const allDotButton = this.closest('tpt-lookbook-slider').querySelectorAll('tpt-lookbook-button');

			allDotButton.forEach((dotItem) => {
				dotItem.classList.remove('active');
			});

			if (index) {
				this.swiper.slideTo(parseInt(index) - 1);
			}

			dotButton.classList.add('active');
		}
	}
}

customElements.define('tpt-lookbook-slider', LookBookSlider);
